import http from '@/api/http';
import type { AccountCompanyResponse } from '../interfaces/company.interface';

export const clientsApi = {
  async getAccountCompanies(): Promise<AccountCompanyResponse[]> {
    const response = await http.get('/clients');
    return response.data?.data ?? [];
  },
};
